export { default as BrandDefault24x24Icon } from './brand_default_icon_24x24.svg';
export { default as BrandDefault48x48Icon } from './brand_default_icon_48x48.svg';
export { default as CashnoteIcon } from './cashnote.svg';
export { default as CouponCardIcon } from './coupon_card.svg';
export { default as CameraIcon } from './ic__camera.svg';
export { default as IcBellLineIcon } from './ic_bell_line.svg';
export { default as ChevronRightIcon } from './ic_chevron_right.svg';
export { default as CheveronRightIcon24x24 } from './ic_chevron_right24x24.svg';
export { default as ChevronDownOutlineIcon24x24 } from './ic_outline_chevron_down_24x24.svg';
export { default as ThreadIcon16x16 } from './ic_thread.svg';
export { default as MoreIcon } from './icon_more.svg';
export { default as IcCheckCircle32x32Icon } from './img_check_circle.svg';
export { default as Home20x20Icon } from './img_house20x20.svg';
export { default as MobileVoucher20x20Icon } from './img_mobile_voucher20x20.svg';
export { default as ArrowRightOutlineIcon } from '@kcd/design-system/dist/icons/ic__system__arrow_right__outline.svg';
export { default as CloseIcon } from '@kcd/design-system/dist/icons/ic__system__dismiss.svg';
export { default as MapIcon } from '@kcd/design-system/dist/icons/ic__system__map__filled.svg';
export { default as MoreOutlineIcon } from '@kcd/design-system/dist/icons/ic__system__more__outline.svg';
export { default as DismissFilledIcon } from '@kcd/design-system/dist/icons/ic_dismiss_circle.svg';
